import { useState, useEffect } from 'react';
import themeService from '../services/ThemeService';

// Custom hook for theme management
export const useTheme = () => {
  const [currentTheme, setCurrentTheme] = useState(themeService.getCurrentTheme());
  const [backgroundStyles, setBackgroundStyles] = useState(themeService.getBackgroundStyles());

  // Update theme
  const setTheme = (themeName) => {
    const success = themeService.setTheme(themeName);
    if (success) {
      setCurrentTheme(themeService.getCurrentTheme());
      setBackgroundStyles(themeService.getBackgroundStyles());
    }
    return success;
  };

  // Get all themes
  const getAllThemes = () => {
    return themeService.getAllThemes();
  };

  // Get enabled themes
  const getEnabledThemes = () => {
    return themeService.getEnabledThemes();
  };

  // Check if has background
  const hasBackground = () => {
    return themeService.hasBackground();
  };

  // Toggle theme on/off
  const toggleTheme = (themeKey) => {
    themeService.toggleTheme(themeKey);
    setCurrentTheme(themeService.getCurrentTheme());
    setBackgroundStyles(themeService.getBackgroundStyles());
  };

  return {
    currentTheme,
    backgroundStyles,
    setTheme,
    getAllThemes,
    getEnabledThemes,
    hasBackground,
    toggleTheme
  };
};

export default useTheme;
